export default function ratingSchema() {
  function organizationSchema() {
    const schema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "JustShip",
      "@id": "https://justship.sg",
      url: "https://justship.sg",
      description: "Cheapest International Shipping Singapore",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Singapore",
        addressRegion: "SG",
        postalCode: "369585",
        streetAddress: "18 Howard Road, Novelty BizCentre, #07-02",
      },
    };
    return {
      __html: JSON.stringify(schema),
    };
  }
  function productSchema() {
    const schema = {
      "@context": "https://schema.org",
      "@type": "Product",
      name: "JustShip - Cheapest International Shipping Singapore",
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "4.9",
        reviewCount: "996",
      },
    };
    return {
      __html: JSON.stringify(schema),
    };
  }
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={organizationSchema()}
        key="organization-jsonld"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={productSchema()}
        key="product-jsonld"
      />
    </>
  );
}
